import { render, staticRenderFns } from "./DeleteSupplierType.vue?vue&type=template&id=74a45ece"
import script from "./DeleteSupplierType.vue?vue&type=script&lang=js"
export * from "./DeleteSupplierType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports